import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SInvoiceCreateSelect = styled.div`
  margin-bottom: 16px;

  ${setFlexDFFDC};
`;
